import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import AllItemsLink from '@swf/sports/components/AllItemsLink/AllItemsLink';
import { ExpandablePanel, Title } from '@swf/sports/components/ExpandablePanel/ExpandablePanel';
import GroupInPanel from '@swf/sports/components/GroupedTemplatePanels/components/GroupInPanel/GroupInPanel';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import { useSportsLandingPageWidget } from '../../model';

import { TXTWCL_All_Matches, TXTWCL_Popular_Matches } from './PopularEvents.messages.json';
import styles from './PopularEvents.scss';

const PopularEvents: React.FC = () => {
  const { widgetSelect } = useSportsLandingPageWidget();
  const popularEvents = useSelector(widgetSelect.popularEvents);
  const { eventTypeId, eventTypeSlug } = useSelector(select.sports.getUrlParams);

  if (!popularEvents.length) {
    return null;
  }

  return (
    <>
      <div className={styles.panel}>
        <ExpandablePanel
          title={
            <Title isNested>
              <Translation {...TXTWCL_Popular_Matches} />
            </Title>
          }
          isNested
        >
          <GroupInPanel groupInPanel={popularEvents} />
        </ExpandablePanel>
      </div>
      <AllItemsLink
        translation={TXTWCL_All_Matches}
        values={{ eventTypeId, eventTypeSlug }}
        alias="sportsMatchFiltering"
      />
    </>
  );
};

export default () => (
  <SportsComponent name="Sports Popular Events Component" timeFormat="RELATIVE">
    <PopularEvents />
  </SportsComponent>
);
